  <!-- Site footer -->
    <footer class="site-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <h6>About</h6>
            <p class="text-justify">paymentor.io <i>CODE WANTS TO BE A SIMPLE </i> platform providing information on 100s of Digital Payment Platform and Service Providers across the globe. We provide information on where to get the right payment API's in your locality, immediate environment, country or regions for your next projects</p>
          </div>

          <div class="col-xs-6 col-md-3">
            <h6>Categories</h6>
            <ul class="footer-links">
              <li><a routerLink="/">Homepage</a></li>
              <li><a routerLink="/">Resources</a></li>
              <li><a routerLink="/code-runner">API's</a></li>
              <li><a href="https://opensource.google/projects/list/featured">Open Source Contribution list (Google)</a></li>
              <li><a href="https://github.com/propenster">Contribution</a></li>
              <li><a routerLink="/">Templates</a></li>
            </ul>
          </div>

          <div class="col-xs-6 col-md-3">
            <h6>Quick Links</h6>
            <ul class="footer-links">
              <li><a routerLink="/">About Us</a></li>
              <li><a routerLink="/contact-us">Contact Us</a></li>
              <li><a routerLink="/">Contribute</a></li>
              <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
              <li><a routerLink="/">Sitemap</a></li>
            </ul>
          </div>
        </div>
        <hr>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-sm-6 col-xs-12">
            <p class="copyright-text">Copyright &copy; 2021 All Rights Reserved by
         <a href="#">paymentor.io</a>.
            </p>
          </div>

          <div class="col-md-4 col-sm-6 col-xs-12">
            <ul class="social-icons">
              <li><a class="facebook" routerLink="#"><i class="fa fa-facebook"></i></a></li>
              <li><a class="twitter" routerLink="#"><i class="fa fa-twitter"></i></a></li>
              <li><a class="dribbble" routerLink="#"><i class="fa fa-dribbble"></i></a></li>
              <li><a class="linkedin" routerLink="#"><i class="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
</footer>
